<template>
  <div class="social-widget">
    <div class="social-widget__title">{{ title }}</div>

    <p class="social-widget__caption">{{ caption }}</p>

    <a
      v-tooltip="{
        content: linkTooltip,
        trigger: 'hover',
        placement: 'social',
        classes: 'social-widget__tooltip'
      }"
      :href="link"
      target="_blank"
      class="social-widget__link"
    >
      {{ formattedLink }}
    </a>

    <div class="social-widget__icons">
      <div v-if="isDomainRu">
        <social-sharing :url="link" inline-template>
          <div class="sharing-list">
            <network network="vk" class="sharing-item sharing-item__vk mr-1">
              <img src="/static/icons/vk.svg" alt="VK" />
            </network>
          </div>
        </social-sharing>
      </div>

      <div v-else>
        <social-sharing :url="link" inline-template>
          <div class="sharing-list">
            <network network="facebook" class="sharing-item sharing-item__fb mr-1">
              <img src="/static/icons/facebook.svg" alt="Facebook" />
            </network>

            <network network="linkedin" class="sharing-item sharing-item__ln mr-1">
              <img src="/static/icons/linkedin.svg" alt="Linkedin" />
            </network>

            <network network="twitter" class="sharing-item sharing-item__tw mr-1">
              <img src="/static/icons/twitter.svg" alt="Twitter" />
            </network>
          </div>
        </social-sharing>
      </div>

      <vbutton
        v-tooltip="{
          content: isRatesExpired ? $tr('rates.expiredProfile') : $tr('badBrowser.copyLink'),
          trigger: 'hover',
          placement: 'top-center'
        }"
        class="social-widget__copy-button"
        color="white"
        icon="icon_copy"
        type="type-icon"
        @click="copy"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isDomainRu } from '@/_helpers/utils.js';
import CopyTextToClipboard from '@/components/mixin/CopyTextToClipboard.js';

export default {
  mixins: [CopyTextToClipboard],

  props: {
    title: {
      type: String,
      default: ''
    },

    caption: {
      type: String,
      default: ''
    },

    link: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters('company_new', ['isRatesExpired']),

    formattedLink() {
      return this.link.split('//')[1];
    },

    linkTooltip() {
      /* Точная длина ссылки, которая влезает */
      return this.link.length > 38 ? this.formattedLink : null;
    }
  },

  methods: {
    isDomainRu,

    copy() {
      if (this.isRatesExpired) {
        return false;
      }

      this.copyLinkToClipboard(this.link);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.sharing-list {
  display: flex;
}

::v-deep .sharing-item {
  margin-right: 7px !important;

  img {
    height: 100% !important;
  }
}

.social-widget {
  &__title {
    @include mixin-text-header;
    margin-bottom: 8px;
    color: $main-dark;
  }

  &__caption {
    @include mixin-text-tag;
    color: $grey-darker;
    margin-bottom: 4px;
  }

  &__link {
    display: block;
    font-weight: 500;
    font-size: 15px;
    color: $green;
    text-decoration: none;
    max-width: 220px;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
  }

  &__icons {
    height: 24px;
    margin-top: 8px;
    display: flex;
    align-items: center;

    & .sharing-list {
      height: 24px;
      max-width: 92px;
    }
    ::v-deep & .sharing-item {
      cursor: pointer !important;
    }
  }

  ::v-deep {
    & .vbutton {
      border: 0 !important;

      & :active,
      &:focus {
        border: 0 !important;
        outline: 0 !important;
      }

      & .button-icon {
        margin: 0 !important;
      }
    }
  }

  &__copy-button {
    height: 24px !important;
    width: 24px !important;
  }
}
</style>
